<mat-form-field>
  <mat-select placeholder="Krankenkasse" #select>
    <mat-option>- Keine -</mat-option>
    <mat-option *ngFor="let payer of payers" [value]="payer._id">
      {{ payer.name }}
    </mat-option>
  </mat-select>
</mat-form-field>
